import http from "../config/axiosConfig/http-common";
import { GetAtributos, GetAtributosClientes, SetAtributos, SetAtributosClientes } from "../config/localstorageConfig/localstorage";
import ServiceBase from "./service.base";

class AtributoService extends ServiceBase {

    getAll(filter) {
        return http.get("/atributos/valoresfilial");
    }

    getValoresFilial() {
        return http.get("/atributos/valoresfilial");
    }
    getValoresCliente() {
        return http.get("/atributos/valorescliente");
    }

    async setCache() {
        const atributos = GetAtributos();
        if (atributos) {
            return;
        }

        try {
            const response = await this.getValoresFilial();
            SetAtributos(response.data.value);
        } catch (e) {
            console.error("Erro ao carregar atributos filial:", e);
            throw e;
        }
    }

    async setCacheClientes() {
        const atributos = GetAtributosClientes();
        if (atributos) {
            return;
        }

        try {
            const response = await this.getValoresCliente();
            SetAtributosClientes(response.data.value);
        } catch (e) {
            console.error("Erro ao carregar atributos cliente:", e);
            throw e;
        }
    }

    get(id) {
        return http.get(`/atributos/${id}`);
    }
}

export default new AtributoService();
